module.exports = __webpack_public_path__ + "static/media/(LH)_MG_6212_-_Joias_Contenporaneas.5c63c60e.jpg";